import * as React from 'react';
import { string, number, oneOf, oneOfType } from 'prop-types';
import { IconMap } from './IconMap';
import { useTheme } from 'emotion-theming';
import { get } from 'styled-system';

const Icon = ({ name, size, className, color, ...rest }) => {
  const theme = useTheme();
  const Comp = IconMap[name];
  return Comp ? (
    <Comp
      name={name}
      width={size}
      height={size}
      className={className}
      color={get(theme, `colors.${color}`, color)}
      {...rest}
    />
  ) : null;
};

export default Icon;

Icon.propTypes = {
  size: oneOfType([string, number]),
  className: string,
  name: oneOf(Object.keys(IconMap)),
  color: string,
};

Icon.defaultProps = {
  size: 20,
  className: '',
  name: undefined,
  color: 'currentColor',
};
